import 'css-chunksrc/client/common/resourceSelection/input/styles.scss';export default {
  "input": "_input_nlqoz_1",
  "opened": "_opened_nlqoz_11",
  "placeholder": "_placeholder_nlqoz_16",
  "selected": "_selected_nlqoz_23",
  "avatar": "_avatar_nlqoz_32",
  "name": "_name_nlqoz_39",
  "toggleIcon": "_toggleIcon_nlqoz_44"
};